import { UtenteDTO } from "../dto/utenteDTO";
import { TipoDifferenzaEnum } from "../enum/tipo-differenza.enumDTO";

export class DifferenzaDTO {
  valoreIniziale: any;
  valoreFinale: any;
  campo: string;
  dettaglioCampo: string;
  tipoDifferenza: TipoDifferenzaEnum;
  nomeAllegato: string;
}
